export default __webpack_public_path__ + "static/media/LAS0920.34I-41366_-25431_0.158821d2.jpg";